import { createReducer } from 'redux-create-reducer'
import {
  REFERRAL_INVITE,
  REFERRAL_INVITE_ERROR,
  REFERRAL_INVITE_SUCCESS,
} from '@disco/constants/ActionTypes'
const initialState = {
  loading: false,
  error: null,
}
export type State = typeof initialState
export const referralInvitesReducer = createReducer<State, any>(initialState, {
  [REFERRAL_INVITE](state) {
    return {
      ...state,
      ...{
        loading: true,
        error: null,
      },
    }
  },

  [REFERRAL_INVITE_SUCCESS](state) {
    return {
      ...state,
      ...{
        loading: false,
        error: null,
      },
    }
  },

  [REFERRAL_INVITE_ERROR](state, { error }) {
    return {
      ...state,
      ...{
        loading: false,
        error,
      },
    }
  },
})
